import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ToastService } from 'app/services/toast.service';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap, switchMap, take, tap, withLatestFrom } from 'rxjs/operators';
import * as fromActions from './actions'
import { StripeCustomerService } from 'app/services/dal/stripecustomer.service';
import { Store } from '@ngrx/store';
import * as UserReducer from 'app/state/user/reducer';



@Injectable()
export class Effects {

  constructor(
    private actions$: Actions,
    private service: StripeCustomerService,
    private store: Store,
    private toastService: ToastService
  ) { }

  getItem$ = createEffect(() => {
    return this.actions$
      .pipe(
        ofType(fromActions.loadItem),
        mergeMap((action) => this.service.getItem(action.id)
          .pipe(
            filter((item) => Boolean(item)),
            map(item => fromActions.loadItemSuccess({ item: item })),
            catchError(error => of(fromActions.loadItemFailure({ error })))
          )
        )
      );
  });


  getItemFromUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(fromActions.loadItemFromUser),
      withLatestFrom(this.store.select(UserReducer.selectUserId)),
      filter(([action, userId]) => Boolean(userId)),
      mergeMap(([action, userId]) => this.service.getItem(userId)
        .pipe(
          filter((item) => Boolean(item)),
          map(item => fromActions.loadItemSuccess({ item: item })),
          catchError(error => of(fromActions.loadItemFailure({ error })))
        )
      )
    );
  });



}
